module.exports = __webpack_public_path__ + "img/home2.de793cba.jpg";